'use client';
import { FaBars } from 'react-icons/fa6';
import { useGlobalContext } from '../../app/tools/globalContext';
// import { BiMenu } from 'react-icons/bi';

export default function BurgerMenu({ className }: { className?: string }) {
  const { mobileMenuOpen, setMobileMenuOpen } = useGlobalContext();

  return (
    <div className={`${className} block md:hidden`}>
      <FaBars
        size={28}
        className='border-dark cursor-pointer rounded border border-themeBlack p-0.5 text-themeBlack transition-colors duration-300 hover:border-gray-600 hover:text-gray-600'
        onClick={() => setMobileMenuOpen(true)}
      />
    </div>
  );
}
